import { render, staticRenderFns } from "./AIcopywriting.vue?vue&type=template&id=17e2f981&scoped=true"
import script from "./AIcopywriting.vue?vue&type=script&lang=js"
export * from "./AIcopywriting.vue?vue&type=script&lang=js"
import style0 from "./AIcopywriting.vue?vue&type=style&index=0&id=17e2f981&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2f981",
  null
  
)

export default component.exports